import React from 'react';
import clsx from 'clsx';

const PublicContainer = ({ children, className, ...props }) => {
  return (
    <div className={clsx('mx-auto w-full max-w-[1200px] px-0 sm:px-4', className)} {...props}>
      {children}
    </div>
  );
};

export default PublicContainer;
